// extracted by mini-css-extract-plugin
module.exports = {"header":"ScheduledPayments_header__2ggX_"};